import * as tslib_1 from "tslib";
import { HttpInterceptorService, RESTService } from '@covalent/http-deprec';
import { environment } from '../../../../environments/environment';
import { throwError } from "rxjs/index";
import { catchError, map } from "rxjs/operators";
var HistlistService = /** @class */ (function (_super) {
    tslib_1.__extends(HistlistService, _super);
    function HistlistService(http) {
        var _this = _super.call(this, http, {
            baseUrl: "" + environment.apiHost,
            path: 'makpak/mphistlist'
        }) || this;
        _this.http = http;
        return _this;
    }
    HistlistService.prototype.loadHistList = function (idOrigin) {
        console.log("Hallo - loadHistList() im idOrigin.service.ts" + idOrigin);
        return this.http.get("" + environment.apiHost + '/makpak/mphistlist?idOrigin=' + idOrigin).pipe(map(function (res) { return res.json(); }), catchError(function (error) { return throwError(error); }), map(function (result) {
            if (result != null) {
                return result;
            }
            console.log(result);
        }));
    };
    return HistlistService;
}(RESTService));
export { HistlistService };
